<template>
  <div class="score-bar">
    <div class="score-container">
      <div
        v-for="(option, index) in options"
        :key="index"
        class="score-box"
        :class="{ 'score-box--active': isActive(index) }"
        :style="getScoreBoxStyle(index)"
        @mouseenter="mouseenter(index)"
        @mouseleave="mouseleave(index)"
        @click="clicked(index)">
        <span class="score-number">{{ index + 1 }}</span>
        <div v-if="showResults && option.score" class="score-percentage">{{ option.score.toFixed(0) }}%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScoreBar',
  props: {
    options: {
      type: Array,
      required: true,
    },
    totalVotes: {
      type: Number,
      default: 0,
    },
    showResults: {
      type: Boolean,
      default: false,
    },
    typeShowResults: {
      type: Boolean,
      default: false,
    },
    interacted: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      hoveredIndex: null,
      isMouseOver: false,
      finished: false,
    };
  },

  methods: {
    isActive(index) {
      if (this.finished) return false;
      return this.hoveredIndex !== null && index <= this.hoveredIndex;
    },
    getScoreBoxStyle(index) {
      return {
        '--score-box-bg': this.isActive(index) ? 'var(--poll-pickedBgColor)' : 'var(--poll-optionsBgColor)',
        '--score-box-color': this.isActive(index) ? 'var(--poll-pickedColor)' : 'var(--poll-optionsColor)',
      };
    },
    clicked(index) {
      this.$emit('clicked', index);
      console.log('ScoreBar clicked', index);
    },
    mouseenter(index) {
      if (this.finished) return;
      this.hoveredIndex = index;
      this.isMouseOver = true;
    },
    mouseleave() {
      if (this.finished) return;
      this.hoveredIndex = this.interacted;
      this.isMouseOver = false;
    },

    setInteractedScore() {
      if (this.interacted !== null) {
        this.hoveredIndex = this.interacted;
      }
    },
  },

  mounted() {
    this.setInteractedScore();
  },
};
</script>

<style scoped lang="scss">
.score-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  .score-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
  }

  .score-box {
    position: relative;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
    background-color: var(--score-box-bg);
    color: var(--score-box-color);
    transition: all 0.2s ease;

    &:hover:not(.score-box--finished) {
      transform: scale(1.05);
    }

    .score-number {
      font-size: 1.5rem;
      font-weight: bold;
    }

    .score-percentage {
      color: white;
      position: absolute;
      bottom: -20px;
      right: 5px;
      font-size: 0.8rem;
      opacity: 0.8;
    }
  }

  .score-indicator {
    margin-top: 15px;
    font-size: 2rem;
    font-weight: bold;
    color: var(--poll-optionsColor);
  }
}

@media (max-width: 486px) {
  .score-bar {
    .score-container {
      gap: 5px;
    }
    .score-box {
      width: 26px;
      height: 26px;

      .score-number {
        font-size: 0.8rem;
      }
    }
  }
}
</style>
